import { GetterTree } from "vuex";
import { ForexBuyState } from "./interface";
import { IStoreRootState } from "@/store/interface";
import { ForexBuyGetter } from "@/feature/Forex/store/buy/constants";
import { ForexBuyDraft } from "@/feature/Forex/api/form/forex-form.interface";

export default <GetterTree<ForexBuyState, IStoreRootState>> {

	[ForexBuyGetter.preventNextRoute]: ({ preventNextRoute }): boolean => preventNextRoute,

	[ForexBuyGetter.currentDraft]: ({ currentDraft }): ForexBuyDraft => currentDraft,

}